import React from "react";
import InventoryReport from "./InventoryReports";

// Api/Reports/CustomerCreditReport - see InventoryReports.jsx
const CustomerCredit = () => <InventoryReport kind="credit" />;

export default CustomerCredit;
